import {getAttrMarkup, getBoundToExpr, IBuildTaskDef, register} from '@wm/transpiler';
import {IDGenerator, updateTemplateAttrs} from '@wm/core';

const tagName = 'div';
const dataSetKey = 'dataset';
const idGen = new IDGenerator('wm_accordion');

const isDynamicAccordion = (node: any) => node.attrs.find((attr: any) => attr.name === 'type' && attr.value === 'dynamic');

register('wm-accordion', (): IBuildTaskDef => {
    return {
        pre: (attrs, shared) => {
          const counter = idGen.nextUid();
          shared?.set('accordion_ref',counter);
          return `<${tagName} wmsTransclude wmAccordion #${counter}="wmAccordion" role="tablist" ${getAttrMarkup(attrs)}>`;
        },
        post: () => `</${tagName}>`,
        template: (node: any, shared) => {
        // check if the accordion is dynamic
        if (isDynamicAccordion(node)) {
          const datasetAttr = node.attrs.find((attr: any) => attr.name === dataSetKey);
          const widgetNameAttr = node.attrs.find((attr: any) => attr.name === 'name');

          if (!datasetAttr) {
            return;
          }
          const boundExpr = getBoundToExpr(datasetAttr.value);

          if (!boundExpr) {
            return;
          }
          updateTemplateAttrs(node, boundExpr, widgetNameAttr.value);
        }
      },
      // To provide parent accordion reference for children
      provide: (attrs, shared: any) => {
        const provider = new Map();
        provider.set('accordion_ref', shared.get('accordion_ref'));
        return provider;
      }
    };
});

export default () => {};
